export const Debug = {
  boot_up: "log_capture_st",
  enable_wanlan: "wanlan_capture_en",
  start_capture: "start_capture",
  save_log: "save_log",
};

export default Debug;
